// BaseNumberRangeFilter.jsx
import React from 'react';
import { Divider, InputNumber, Space } from 'antd';

/**
 * Filter khoảng số (ví dụ: doanh số, điểm, số lần...)
 *
 * @param {string} name
 * @param {object} query
 * @param {function} onChangeFilter
 * @param {string[]} placeholder
 * @param {string} fromSuffix
 * @param {string} toSuffix
 */
const BaseNumberRangeFilter = ({
    name,
    query,
    onChangeFilter,
    fromSuffix = `${name}_from`,
    toSuffix = `${name}_to`,
    placeholder = ['Từ', 'Đến'],
    min = 0,
    step = 1,
    width = '100%',
}) => {
    return (
        <Space.Compact style={{ width }}>
            <InputNumber
                min={min}
                step={step}
                style={{ width: '50%' }}
                placeholder={placeholder[0]}
                value={query[fromSuffix] ? Number(query[fromSuffix]) : undefined}
                onChange={(val) => onChangeFilter(fromSuffix, val)}
                allowClear
            />
            <Divider type="vertical" />
            <InputNumber
                min={min}
                step={step}
                style={{ width: '50%' }}
                placeholder={placeholder[1]}
                value={query[toSuffix] ? Number(query[toSuffix]) : undefined}
                onChange={(val) => onChangeFilter(toSuffix, val)}
                allowClear
            />
        </Space.Compact>
    );
};

export default BaseNumberRangeFilter;
